import Swiper from "swiper/js/swiper.js";

export default class NavCarousel {
  constructor(options) {
    const _defaults = {};
    this.defaults = Object.assign({}, _defaults, options);
  }

  init() {
    this.carousel();
  }

  carousel() {
    var navSwiper = new Swiper(".js-nav-carousel", {
      slidesPerView: "auto",
      spaceBetween: 0,
      navigation: {
        nextEl: ".js-nav-carousel-right-arrow",
        prevEl: ".js-nav-carousel-left-arrow"
      }
    });
  }

}


// WEBPACK FOOTER //
// ./static/js/components/NavCarousel.js